import gql from 'graphql-tag';
// import format from 'date-fns/format';
// import { capitalize } from 'lodash';

import client from '../../../utils/apolloClient';

const searchAbandonedOrderQuery = gql`
  query searchAbandonedOrderQuery(
    $orderReference: String
    $from: Int
    $size: Int
  ) {
    search_abandoned_order(
      input: {
        filter: { abandoned_order_filter: { order_reference: $orderReference } }
        size: $size
        from: $from
      }
    ) {
      total_pages
      total_size
      abandoned_order_listing {
        abandoned_order_id
        audit {
          created_at
          updated_at
          created_by
          updated_by
        }
        email
        order_id
        order_reference
        reason
        user_id
      }
    }
  }
`;

export const fetchAbandonedOrder = async ({ orderReference, from, size }) => {
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchAbandonedOrderQuery,
      variables: {
        orderReference,
        from,
        size,
      },
      fetchPolicy: 'network-only',
    });
    if (
      data &&
      data.data &&
      data.data.search_abandoned_order &&
      Array.isArray(data.data.search_abandoned_order.abandoned_order_listing)
    ) {
      return data.data.search_abandoned_order;
    }

    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default {};
